import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useMemo, useState } from 'react';
import { useOptionalDependencies } from '@servicetitan/react-ioc';
import { getElementName } from './get-element-name';
import { HistoryManager } from '../history-manager';
export function webComponent(props) {
    var _a;
    const { basename, bundleInfo, eventBus, exposedDependencies, ldService, logService } = props;
    const { WebComponent, disposer, mfeSupportsRerendering, version } = bundleInfo;
    const elementName = getElementName(bundleInfo);
    const exposedInstanceDependencies = ensureLDVersion(props.exposedInstanceDependencies, (_a = bundleInfo.bundledWith) === null || _a === void 0 ? void 0 : _a['launchdarkly-js-client-sdk']);
    return ({ LoadingFallback, ...props }) => {
        const [isLoading, setIsLoading] = useState(true);
        const [historyManager] = useOptionalDependencies(HistoryManager);
        const handleRef = (webComponent) => {
            webComponent === null || webComponent === void 0 ? void 0 : webComponent.provide({
                ldService,
                logService,
                historyManager,
                exposedDependencies,
                exposedInstanceDependencies,
                eventBus,
                basename,
                onReady: () => {
                    setIsLoading(false);
                },
                onDispose: () => {
                    disposer();
                },
            });
        };
        // Stringify data object so that it can be passed as a data-attribute
        const stringifiedData = useMemo(() => JSON.stringify(props.data), [props.data]);
        /*
         * Set key for rendering the web component so that if the data from the Host change,
         * and the MFE's version of startup doesn't support watching for data changes, then
         * the web component will be re-mounted whenever the data changes.
         * This is only used as a fallback when the MFE's version is older.
         */
        const key = mfeSupportsRerendering ? undefined : stringifiedData;
        const dataAttrs = useMemo(() => composeDataAttributes(props.data), [props.data]);
        const styleUrls = getStyleUrls(bundleInfo);
        return (_jsxs(Fragment, { children: [isLoading && _jsx(LoadingFallback, {}), _jsx(WebComponent, { 
                    // @ts-expect-error because property ref does not exist on IntrinsicAttributes
                    ref: handleRef, class: props.className, ...(styleUrls && { 'style-urls': styleUrls }), ...dataAttrs, "data-mfe-data": stringifiedData, "data-mfe-name": elementName, ...(version && { 'data-mfe-version': version }) }, key)] }));
    };
}
/*
 * Convert camelCase data props to kebab-case data attributes, prepended with data-
 * Ex: fooBar -> data-foo-bar
 */
function composeDataAttributes(data = {}) {
    return Object.fromEntries(Object.entries(data).map(([key, value]) => [
        'data-' + key.replace(/[A-Z]/g, letter => '-' + letter.toLowerCase()),
        value,
    ]));
}
function ensureLDVersion(exposedInstanceDependencies = {}, version) {
    var _a;
    if (version && !((_a = exposedInstanceDependencies.launchDarkly) === null || _a === void 0 ? void 0 : _a.ldService)) {
        return { ...exposedInstanceDependencies, launchDarkly: { version } };
    }
    return exposedInstanceDependencies;
}
function getStyleUrls({ urls }) {
    if (urls.css.length) {
        return encodeURIComponent(JSON.stringify(urls.css));
    }
}
//# sourceMappingURL=web-component.js.map